import React from 'react';
import ReactDOM from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './lib/msalInstance';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// SSO/OIDC disable logic removed. Always use MSAL authentication for app access.
msalInstance.initialize().then(() => {
  return msalInstance.handleRedirectPromise();
}).then(() => {
  root.render(
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  );
  reportWebVitals();
}).catch((error) => {
  // Ignore no_token_request_cache_error - it happens when there's no redirect in progress
  if (error?.errorCode !== 'no_token_request_cache_error') {
    console.error('Error during initialization:', error);
  }
  // Render app anyway
  root.render(
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  );
  reportWebVitals();
});
